import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { catchError, of, tap } from 'rxjs';
import { ActivityResponse } from 'src/app/model/dto/ActivityResponse';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { ActivityService } from 'src/app/modules/agenda/services/activity-services';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { InviteMiniJpoDto } from './inviteMiniJpoDto.model';
import { ProfilDetails } from 'src/app/model/profilDetails';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-jpo-form',
  templateUrl: './mini-jpo-form.component.html',
  styleUrls: ['./mini-jpo-form.component.css'],
})
export class MiniJpoFormComponent implements OnInit {
  showSpinner = false;
  alreadyConfirm: boolean = false;

  submitSuccess: boolean = false;
  activity!: ActivityResponse;
  miniJpoForm!: FormGroup;

  prenomCtrl!: FormControl;
  emailCtrl!: FormControl;
  nomCtrl!: FormControl;
  indicatifCtrl!: FormControl;

  genderCtrl!: FormControl;
  professionnalSituationCtrl!: FormControl;
  lieuDeProvenanceCtrl!: FormControl;
  waveNumberCtrl!: FormControl;
  lieuDeParticipationCtrl!: FormControl;

  regions!: any;
  lieuMiniJPO!: any;

  lieuJPO!: any;

  filled: boolean = false;
  erreur: boolean = false;
  date: Date = new Date();
  isLoading: boolean = true;
  session: boolean = false;
  noSession: boolean = false;
  activityId: number | undefined;
  infoResponse!: string;
  isSubmitting: boolean = false;
  activityType: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerServiceService,
    private service: ActivityService,
    private router: ActivatedRoute
  ) {}
  ngOnInit() {
    const type = this.router.snapshot.params['type'];
    if (type == 'mini-jpo') {
      this.activityType = 'MINIJPO';
      this.lieuMiniJPO = ProfilDetails.MiniJpo2025;

      this.getCurrentJpo(this.activityType);
    }
    if (type == 'jpo') {
      this.activityType = 'JPO';
      this.lieuJPO = ProfilDetails.Jpo2025;
      this.getCurrentJpo(this.activityType);
    }
    // console.log('type : ', type);
    this.spinnerService.showSpinner();
    this.regions = LOCALISATIONS.Regions;
    // console.log('Les lieu de JPO : ', this.lieuMiniJPO);
    this.initControls();
    this.initForm();
    this.populateLieuxArray();
  }

  onSubmitForm() {
    // console.log('Le formulaire : ', this.miniJpoForm.value);
    if (this.miniJpoForm.valid) {
      this.filled = false;
      this.isSubmitting = true;
      const formValue = this.miniJpoForm.value;
      // console.log('Le formulaire est valide : ', this.miniJpoForm.value);

      const dto: InviteMiniJpoDto = {
        firstName: formValue['prenom'],
        lastName: formValue['nom'],
        email: formValue['email'],
        gender: formValue['gender'],
        telephone: this.indicatifCtrl.value + formValue['telephone'],
        statusPro: formValue['professionnalSituation'],
        lieuProvenane: formValue['lieu'],
      };
      if (this.activityType == 'MINIJPO') {
        dto.lieuDeParticipationMINIJPO = formValue['lieuDeParticipation'];
      }
      if (this.activityType == 'JPO') {
        // console.log('array : ', formValue['lieuDeParticipationJPO']);
        const list: any[] = [];
        if (formValue['lieuDeParticipationJPO'][0]) {
          list.push(this.lieuJPO[0]);
        }
        if (formValue['lieuDeParticipationJPO'][1]) {
          list.push(this.lieuJPO[1]);
        }
        dto.lieuDeParticipationJPO = list;
      }

      // console.log('object : ', dto);
      if (this.activityId != undefined) {
        this.showSpinner = true;
        window.scrollTo(0, 0);
        this.service
          .jpoSubmission(dto, this.activityId)
          .pipe(
            tap((response: CustomResponse) => {
              this.showSpinner = false;
              switch (response.status) {
                case 200:
                  this.miniJpoForm.reset();
                  this.submitSuccess = true;
                  this.alreadyConfirm = false;
                  this.session = false;
                  this.noSession = false;
                  this.infoResponse = response.object as string;
                  break;

                case 409:
                  this.alreadyConfirm = true;
                  this.submitSuccess = false;
                  this.session = false;
                  this.noSession = false;
                  this.infoResponse = response.object as string;
                  break;

                case 404:
                  this.submitSuccess = false;
                  this.session = false;
                  this.noSession = true;
                  this.alreadyConfirm = false;
                  break;
              }
            }),

            catchError((error) => {
              console.error('Erreur API : ', error);

              this.erreur = true;
              this.infoResponse =
                'Une erreur est survenue. Veuillez réessayer plus tard.';
              this.isSubmitting = true;
              setTimeout(() => {
                this.infoResponse = '';
                this.erreur = false;
                window.location.reload();
              }, 3500);

              // console.log('le formulaire : ', this.miniJpoForm);
              return of(null);
            })
          )
          .subscribe();
      }
    } else {
      // console.log('Le formulaire  invalid: ', this.miniJpoForm.value);

      this.filled = true;
    }
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.miniJpoForm.get(controlName);
    return control && control.invalid && control.touched;
  }

  private initForm() {
    this.miniJpoForm = this.formBuilder.group({
      prenom: this.prenomCtrl,
      nom: this.nomCtrl,
      email: this.emailCtrl,
      professionnalSituation: this.professionnalSituationCtrl,
      lieu: this.lieuDeProvenanceCtrl,
      indicatif: this.indicatifCtrl,
      telephone: this.waveNumberCtrl,
      gender: this.genderCtrl,
    });
    if (this.activityType == 'JPO') {
      // 👉 créer le FormArray AVEC le validator
      const lieuxArray = this.formBuilder.array([], this.atLeastOneChecked);

      // 👉 l’ajouter proprement dans le form
      this.miniJpoForm.addControl('lieuDeParticipationJPO', lieuxArray);

      // this.miniJpoForm.addControl(
      //   'lieuDeParticipation17',
      //   this.formBuilder.control('', Validators.required)
      // );
      // this.miniJpoForm.addControl(
      //   'lieuDeParticipation18',
      //   this.formBuilder.control('', Validators.required)
      // );
    }
    if (this.activityType == 'MINIJPO') {
      this.miniJpoForm.addControl(
        'lieuDeParticipation',
        this.lieuDeParticipationCtrl
      );
    }
  }
  private initControls() {
    this.professionnalSituationCtrl = this.formBuilder.control(
      '',
      Validators.required
    );
    this.lieuDeProvenanceCtrl = this.formBuilder.control(
      '',
      Validators.required
    );
    this.waveNumberCtrl = this.formBuilder.control('', Validators.required);
    this.genderCtrl = this.formBuilder.control('', Validators.required);
    this.prenomCtrl = this.formBuilder.control('', Validators.required);
    this.nomCtrl = this.formBuilder.control('', Validators.required);
    this.indicatifCtrl = this.formBuilder.control('+221', Validators.required);
    this.lieuDeParticipationCtrl = this.formBuilder.control(
      '',
      Validators.required
    );
    this.indicatifCtrl.disable();

    this.emailCtrl = this.formBuilder.control('', [
      Validators.email,
      Validators.required,
    ]);
  }

  private getCurrentJpo(activityType: string) {
    this.service
      .getCurrentJpo(activityType)
      .pipe(
        tap((response: CustomResponse) => {
          if (response.status == 200) {
            // console.log('Je suis le JPO : ', response);
            this.activity = response.object as ActivityResponse;
            // console.log('activity : ', this.activity);
            this.session = true;
            this.spinnerService.hideSpinner();
            this.isLoading = false;
            this.noSession = false;
            this.activityId = this.activity.id;
          } else if (response.status == 404) {
            this.session = false;
            this.noSession = true;
            this.spinnerService.hideSpinner();
            this.isLoading = false;
          }
        })
      )
      .subscribe();
  }
  atLeastOneChecked(control: AbstractControl) {
    const values = control.value as boolean[];

    return values.some((v) => v)
      ? null // -> valide si ≥ 1 case cochée
      : { required: true };
  }

  populateLieuxArray() {
    const array = this.miniJpoForm.get('lieuDeParticipationJPO') as FormArray;

    this.lieuJPO.forEach(() => {
      array.push(this.formBuilder.control(false));
    });
  }
}
